import { Search } from "@mui/icons-material";
import { Box, Typography, useTheme } from "@mui/material";
import React from "react";

export interface EmptyStateProps {
  title?: string;
  height?: number | string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title = "No entries found",
  height = "100%",
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height,
        gap: 2,
        paddingY: 16,
      }}
    >
      <Search sx={{ fontSize: 56 }} />
      <Typography
        sx={{
          color: theme.colors.text[5],
          fontSize: 20,
          fontWeight: 700,
        }}
        variant="body1"
      >
        {title}
      </Typography>
    </Box>
  );
};
